import React from 'react';
import hljs from 'highlight.js';
import 'highlight.js/styles/vs2015.css';
import 'tailwindcss/tailwind.css'; // Import Tailwind CSS styles

const CodeBlock = ({ code }) => {
  // Add two empty spaces at the end of each line
  const codeWithSpaces = code.split('\n').map(line => line + '  ').join('\n');
  const highlightedCode = hljs.highlight('python', codeWithSpaces).value;

  return (
    <div className="overflow-x-auto">
      <pre
        className="bg-gray-900 p-4 rounded-md overflow-y-auto"
        style={{
          paddingRight: '1em',
          boxSizing: 'border-box',
        }}
      >
        <code
          className="text-white text-xs font-mono block"
          dangerouslySetInnerHTML={{ __html: highlightedCode }}
        />
      </pre>

      {/* Add scoped styles for the custom scrollbar */}
      <style jsx>{`
        /* For WebKit browsers */
        ::-webkit-scrollbar {
          width: 12px;
        }
        
        /* Track */
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: #888;
        }
        
        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </div>
  );
};

export default CodeBlock;
